import classNames from 'classnames';

type NobatDoctorCardShimmerProps = {
  className?: string;
};

const NobatDoctorCardShimmer = ({ className }: NobatDoctorCardShimmerProps) => {
  return (
    <div
      className={classNames(
        className,
        'w-[172px] min-h-[268px] flex flex-col rounded-3xl border border-border-primary/20 bg-surface-primary overflow-hidden animate-pulse',
      )}
    >
      <div className="h-[72px] bg-surface-tertiary px-3 pt-3">
        <div className="flex justify-between">
          <div className="h-5 w-12 rounded-full bg-surface-secondary" />
          <div className="h-5 w-20 rounded-full bg-surface-secondary" />
        </div>
      </div>

      <div className="-mt-8 flex justify-center">
        <div className="h-16 w-16 rounded-full bg-surface-secondary" />
      </div>

      <div className="flex flex-1 flex-col items-center gap-y-2 px-3 pb-3 pt-4">
        <div className="h-4 w-16 rounded bg-surface-secondary" />
        <div className="h-5 w-full rounded bg-surface-secondary" />
        <div className="h-4 w-3/4 rounded bg-surface-tertiary" />
        <div className="mt-auto h-10 w-full rounded-full bg-surface-secondary" />
      </div>
    </div>
  );
};

export default NobatDoctorCardShimmer;
